import { useDispatch, useSelector } from 'react-redux'

import { UsersState, usersSelector } from '../../hasura/slices/users'
import { useCaseImageDownloads } from '../../hooks/useCaseImageDownloads'
import { setCaseImageDownloadsAction } from '../../hasura/slices/cases'

export default () => {
  const dispatch = useDispatch()

  const { user }: UsersState = useSelector(usersSelector)

  useCaseImageDownloads((caseImageDownloads: any) => {
    dispatch(setCaseImageDownloadsAction(caseImageDownloads))
  }, user!)

  return null
}
